<form [formGroup]="formGroup">
  @if (!editMode) {
  <mat-form-field class="w-full" id="{{ id }}">
    <mat-label class="custom-label-error">{{ label }}</mat-label>
    <input matInput id="{{ id }}Input" matInput type="text" readonly formControlName="{{ controlName }}" />
  </mat-form-field>
  } @if (editMode && options) {
  <mat-form-field class="w-full" id="{{ id }}">
    <mat-label class="custom-label-error">{{ label }}</mat-label>
    <mat-select placeholder="{{ placeholder }}" id="{{ id }}DropdownInput" type="text" formControlName="{{ controlName }}">
      @for (option of options; track option) {
      <mat-option id="{{ controlName }}Option" value="{{ translationService.translate(option) }}">{{
        translationService.translate(option)
      }}</mat-option>
      }
    </mat-select>
    @if (formGroup.get(controlName).invalid) {
    <mat-error class="custom-error" id="dropdown-input-error">{{
      translationService.translate('selectAtleastOneValueErrorText')
    }}</mat-error>
    }
  </mat-form-field>
  } @if (editMode && optionsForCustomer) {
  <mat-form-field class="w-full" id="{{ id }}">
    <mat-label class="custom-label-error">{{ label }}</mat-label>
    <mat-select placeholder="" id="{{ id }}DropdownInput" type="text" formControlName="{{ controlName }}">
      @for (option of optionsForCustomer; track option.id) {
      <mat-option id="{{ controlName }}Option" value="{{ option.id }}">{{ translationService.translate(option.code) }}</mat-option>
      }
    </mat-select>
    @if (formGroup.get(controlName).invalid) {
    <mat-error class="custom-error" id="dropdown-input-error">{{
      translationService.translate('selectAtleastOneValueErrorText')
    }}</mat-error>
    }
  </mat-form-field>
  }
</form>
